import { ScrollReveal } from "@/components/base/ScrollReveal";

const strengths = [
  {
    no: "01",
    title: "最短即日のスピード対応",
    desc: "管理会社・オーナー様からのご連絡に最短即日でお見積もり。退去から次の入居者様募集までの空室期間を最小化します。",
    icon: "ri-timer-flash-line",
  },
  {
    no: "02",
    title: "全工程ワンストップ",
    desc: "原状回復・内装・設備・電気・清掃まで全て自社チームで完結。複数業者の手配コストと工程ロスを徹底削減します。",
    icon: "ri-stack-line",
  },
  {
    no: "03",
    title: "明朗な見積もりと安心保証",
    desc: "工事内容ごとに項目を明記したわかりやすい見積書。施工後のアフターフォローまで、責任を持って対応します。",
    icon: "ri-shield-star-line",
  },
];

export default function Strengths() {
  return (
    <section
      id="strengths"
      role="region"
      aria-label="選ばれる理由"
      className="relative bg-foreground-950 py-20 md:py-32 px-6 md:px-16 lg:px-24 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://www.stylekoubou.com/image/top/slide02_1200.webp?20161215"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950 via-foreground-950/85 to-foreground-950"></div>

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-primary-400"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-primary-300 font-medium">
              Why Choose Wind
            </span>
            <span className="w-10 h-px bg-primary-400"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            選ばれる、<br /><span className="text-primary-300">3つの理由</span>。
          </h2>
        </div>

        <ScrollReveal direction="up" stagger threshold={0.03} rootMargin="0px 0px -10px 0px">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {strengths.map((s) => (
              <div
                key={s.no}
                className="relative p-7 md:p-9 rounded-2xl bg-background-50/5 border border-background-50/10 backdrop-blur-sm hover:bg-background-50/10 hover:border-primary-400/40 transition-all duration-500"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-heading text-5xl md:text-6xl font-bold text-primary-400/30">
                    {s.no}
                  </span>
                  <span className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className={`${s.icon} text-background-50 text-2xl`}></i>
                  </span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-4 leading-snug">
                  {s.title}
                </h3>
                <p className="text-background-50/70 text-sm md:text-base leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}